import React, { useState, useEffect } from "react";
import {
  Drawer,
  Box,
  Typography,
  IconButton,
  Divider,
  CircularProgress,
  Button,
} from "@mui/material";
import {
  Close as CloseIcon,
  ArrowForward as ArrowForwardIcon,
} from "@mui/icons-material";
import styled from "@emotion/styled";

const DrawerHeader = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${(props) => props.theme.spacing(4, 6)};
`;

const DrawerContent = styled(Box)`
  padding: ${(props) => props.theme.spacing(6)};
  flex: 1;
  overflow-y: auto;
`;

const DrawerFooter = styled(Box)`
  padding: ${(props) => props.theme.spacing(4, 6)};
  border-top: 1px solid ${(props) => props.theme.palette.divider};
  background-color: ${(props) => props.theme.palette.background.paper};
`;

const CommonDrawer = ({
  open,
  onClose,
  title,
  subtitle,
  dataId,
  fetchDataFn,
  renderContent,
  footerButtonLabel,
  onFooterButtonClick,
  width = 450,
}) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (open && fetchDataFn && dataId) {
      const loadData = async () => {
        setLoading(true);
        setError(null);
        try {
          const result = await fetchDataFn(dataId);
          setData(result);
        } catch (err) {
          console.error("Error fetching drawer data:", err);
          setError("Errore nel caricamento dei dati.");
        } finally {
          setLoading(false);
        }
      };
      loadData();
    }
  }, [open, dataId, fetchDataFn]);

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: { width: { xs: "100%", sm: width } },
      }}
    >
      <DrawerHeader>
        <Box>
          <Typography variant="h5" fontWeight="bold">
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="body2" color="textSecondary">
              {subtitle}
            </Typography>
          )}
        </Box>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DrawerHeader>

      <Divider />

      <DrawerContent>
        {loading ? (
          <Box display="flex" justifyContent="center" py={10}>
            <CircularProgress />
          </Box>
        ) : error ? (
          <Box py={5} textAlign="center">
            <Typography color="error">{error}</Typography>
            <Button onClick={() => window.location.reload()} sx={{ mt: 2 }}>
              Riprova
            </Button>
          </Box>
        ) : (
          renderContent && renderContent(data)
        )}
      </DrawerContent>

      <Divider />

      <DrawerFooter>
        <Button
          fullWidth
          variant="contained"
          size="large"
          endIcon={<ArrowForwardIcon />}
          onClick={onFooterButtonClick}
          /* disabled={loading || !data} */
        >
          {footerButtonLabel || "Visualizza Dettagli Completi"}
        </Button>
      </DrawerFooter>
    </Drawer>
  );
};

export default CommonDrawer;
